import React from "react";
import { JumbotronD2C } from "./JumbotronD2C";
import { SectionKeys } from "./SectionKeys";
import { SectionCalculator } from "./SectionCalculator";
import { SectionSteps } from "./SectionSteps";
import { StartInvesting } from "./StartInvesting";
import { resource } from "@app/common/localization/resource";
import { useDocumentTitle } from "@app/common/hooks/useDocumentTitle";
import { Layout } from "@app/common/components/Layout";

export const D2CPage: React.VFC = () => {
  useDocumentTitle(resource("landing.htmlTitle"));

  return (
    <Layout>
      <main>
        <JumbotronD2C />
      </main>
    </Layout>
  );
};
